// src/components/Flipbook.js
import React, { useEffect, useRef } from "react";
import "./Book.css"; // Import the CSS for styling

import Image1 from "../../Assets/Images/Brochure/Img-17.jpg";
import Image2 from "../../Assets/Images/Brochure/Img-18.jpg";
import Image3 from "../../Assets/Images/Brochure/Img-19.jpg";
import Image4 from "../../Assets/Images/Brochure/Img-20.jpg";
import Image5 from "../../Assets/Images/Brochure/Img-21.jpg";
import Image6 from "../../Assets/Images/Brochure/Img-22.jpg";
import Image7 from "../../Assets/Images/Brochure/Img-23.jpg";
import Image8 from "../../Assets/Images/Brochure/Img-24.jpg";

import playAudio from "../../Assets/Sound/pageFlipSound.mp3";

const Book = () => {
  const bookRef = useRef(null);
  const audio = new Audio(playAudio)
  

  const flipBook = () => {
    const elBook = bookRef.current;
    if (!elBook) return;

    elBook.style.setProperty("--c", 0); // Set current page
    const pages = elBook.querySelectorAll(".bookPage");
    pages.forEach((page, idx) => {
      page.style.setProperty("--i", idx);
      page.addEventListener("click", (evt) => {
        audio.play()
        const curr = evt.target.closest(".back") ? idx : idx + 1;
        elBook.style.setProperty("--c", curr);
      });
    });
  };

  useEffect(() => {
    flipBook();
  }, []);
  return (
    <div className="bookContainer">
      <div class="book" ref={bookRef}>
        <div class="bookPage">
          <div class="front">
            <img src={Image1} height="100%" width="100%" alt="" />
          </div>
          <div class="back">
            <img src={Image2} height="100%" width="100%" alt="" />
          </div>
        </div>

        <div class="bookPage">
          <div class="front">
            <img src={Image3} height="100%" width="100%" alt="" />
          </div>
          <div class="back">
            <img src={Image4} height="100%" width="100%" alt="" />
          </div>
        </div>

        <div class="bookPage">
          <div class="front">
            <img src={Image5} height="100%" width="100%" alt="" />
          </div>
          <div class="back">
            <img src={Image6} height="100%" width="100%" alt="" />
          </div>
        </div>

        <div class="bookPage">
          <div class="front">
            <img src={Image7} height="100%" width="100%" alt="" />
          </div>
          <div class="back">
            <img src={Image8} height="100%" width="100%" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;
